import {SpeechRecognitionTinkController} from './speech-recognition-tink';

require('./speech-recognition-config.scss');
require('./speech-recognition-settings.scss');


const default_engine_id = 'DFLT';
const testing_engine_id = 'TEST';

export const available_engines = [
  {id  : default_engine_id,
   name: gettext('Default'),
   $component: {
     template: gettext('Будут использоваться настройки по-умолчанию.'),
  }},
  {id  : testing_engine_id,
   name: gettext('Testing'),
   $component: {
     template: gettext('Имитация работы без обращения к внешним сервисам, результатом будет случайный текст.'),
  }},
  {id  : 'TINK',
   name: gettext('Tinkoff VoiceKit'),
   $component: {
     controller: SpeechRecognitionTinkController,
     template  : require('./speech-recognition-tink.html'),
  }},
]


export function SpeechRecognitionEngineConfigDirective(
  $compile, $controller,
  $log, $http, $q, $templateCache
) {

  function linker(scope, element, attrs) {
    let active_scope;
    let active_element;
    let active_controller;

    let destroy = () => {
        if (active_element) {
          active_element.remove();
          active_element.unbind();
          active_element = undefined;
        }
        if (active_scope) {
          active_scope.$destroy();
          active_scope = undefined;
        }
        scope.$emit('speech-recognition-engine-stopped', {controller: active_controller});
    }

    if (!scope.config) {
      $log.error('Attribute "config" required');
    }

    else {
      scope.$on('$destroy', () => { destroy(); });

      scope.$watch('config.engine', (engine) => {
        if (engine) {
          let options = engine.$component;
          let controller = options && options.controller;
          let template = options && (options.template || options.templateUrl);
          let template_promise;

          if (!template) {
            template_promise = $q.when(null);
          } else {
            template_promise = options.template
              ? $q.when(options.template)
              : $http.get(options.templateUrl, {cache: $templateCache})
                     .then((result) => result.data);
          }

          template_promise
            .then((template) => {
              destroy();
              element.html(template || '');

              active_scope = scope.$new();
              active_element = $compile(element.contents())(active_scope);

              if (controller) {
                active_controller = $controller(controller, {$scope: active_scope});

                if (angular.isFunction(active_controller.$onInit)) {
                  active_controller.$onInit();
                }
                if (angular.isFunction(active_controller.$onDestroy)) {
                  active_scope.$on('$destroy', () => { active_controller.$onDestroy(); });
                }
              } else {
                active_controller = undefined;
              }

              scope.$emit('speech-recognition-engine-started', {controller: active_controller});
            })
            .catch((error) => {
              $log.error(error);
            });
        } else {
          destroy();
        }
      });
    }
  }

  return {
    restrict: 'E',
    replace : true,
    link    : linker,
    scope   : {config: '=', errors: '='},
  }
}


class SpeechRecognitionGlobalSettingsController {
  constructor($scope, $element, $timeout) {
    this.$scope = $scope;

    $timeout(() => {
      this.$input = $element.find('input[type=hidden]')[0];

      if (this.$input && this.$input.value) {
        try {
          $scope.config = JSON.parse(this.$input.value);
        } catch(exc) {
          console.error(exc);
          $scope.config = {};
        }
      } else {
        $scope.config = {};
      }

      $scope.enabled = !!$scope.config.engine;
      $scope.errorMessage = {fields: {}};

      $scope.$watch('config', (config) => {
        if ($scope.enabled) {
          this.$input.value = JSON.stringify(config);
        }
      }, true);

      $scope.$watch('enabled', (enabled) => {
        if (enabled) {
          this.$input.value = JSON.stringify($scope.config);
        } else {
          this.$input.value = '';
        }
      });
    });
  }
}


export const SpeechRecognitionGlobalSettingsComponent = {
  restrict   : 'E',
  transclude : true,
  template   : require('./speech-recognition-settings.html'),
  controller : SpeechRecognitionGlobalSettingsController,
}


class SpeechRecognitionConfigController {
  constructor($scope, $element) {
    this.$scope = $scope;
    this.$element = $element;

    this.availableEngines = angular.copy(available_engines);

    if (!this.defaultAvailable) {
      let idx = this.availableEngines.findIndex((engine) => engine.id == default_engine_id);
      if (0 <= idx) {
        this.availableEngines.splice(idx, 1);
      }
    }

    if (!window.speech_processing || !window.speech_processing.speech_recognition_debug) {
      let idx = this.availableEngines.findIndex((engine) => engine.id == testing_engine_id);
      if (0 <= idx) {
        this.availableEngines.splice(idx, 1);
      }
    }
  }

  $onInit() {
    let $scope = this.$scope;
    let $ctrl = $scope.$ctrl;

    if (!this.errors) {
      // fake `ErrorHandlerService.filterErrorMessage`
      this.errors = {fields: {}};
    }

    let config = this.externalConfig;
    let engine;

    this.previousConfig = config ? angular.copy(config) : {};

    if (config && config.engine) {
        engine = this.availableEngines.find(({id}) => id == config.engine);
    }

    if (engine === undefined) {
        engine = this.availableEngines[0]
        config = {};
    }

    this.config = angular.merge(
      config ? angular.copy(config) : {},
      {engine: engine},
    );

    $scope.$watch('$ctrl.config', (config) => {
      this.checkAndSave(config);
    }, true);

    $scope.$on('speech-recognition-engine-started', (event, args) => {
      if (args && args.controller) {
        this.engineController = args.controller;
      } else {
        delete this.engineController;
      }
      this.checkAndSave(this.config);
    });

    $scope.$on('speech-recognition-engine-stopped', (event, args) => {
      if (args && args.controller && args.controller === this.engineController) {
        delete this.engineController;
      }
    });
  }

  get defaultAvailable() {
    let attr = this.$element.attr('hide-default');
    if (angular.isString(attr)) {
      if (!['false', 'no'].includes(attr.toLowerCase())) {
        return false;
      }
    }
    if (window.speech_processing && !window.speech_processing.speech_recognition_default_available) {
        return false;
    }
    return true;
  }

  get forceAvailable() {
    let attr = this.$element.attr('hide-force');
    if (angular.isString(attr)) {
      if (!['false', 'no'].includes(attr.toLowerCase())) {
        return false;
      }
    }
    return true;
  }

  checkAndSave(config) {
    this.resetErrors();
    let result = this.checkConfig(config, this.errors);
    if (!result.error) { this.saveConfig(config); }
    else { this.resetConfig(); }
  }

  resetErrors() {
    if (this.errors) {
      this.errors.error = false;
      this.errors.text = '';
      this.errors.fields = {};
    }
  }

  checkConfig(config, result) {
    if (!result) { result = {}; }
    if (!result.fields) { result.fields = {}; }
    if (!config) { config = this.config; }

    let engine = config.engine;
    let errors = 0;

    if (!engine) {
      result.fields['engine'] = gettext('Обязательное поле');
      errors++;
    } else {
      let handle_validation = (what) => {
        if (what === false) {
          errors++;
        } else
        if (angular.isString(what)) {
          result.text = what;
          errors++;
        } else
        if (angular.isObject(what)) {
          angular.forEach(what, (value, key) => {
            result.fields[key] = angular.isString(value) ? value : gettext('Ошибка');
            errors++;
          });
        }
      }

      if (engine.$component && engine.$component.validate) {
        handle_validation(engine.$component.validate(config));
      }
      if (this.engineController && this.engineController.validate) {
        handle_validation(this.engineController.validate(config));
      }
    }

    if (errors && !result.error) {
      if (!result.text) {
        result.text = gettext('Что-то пошло не так');
      }
      result.error = true;
    }

    if (result.error === undefined) {
      result.error = false;
    }

    return result;
  }

  saveConfig(config) {
    if (this.externalConfig) {
      if (config) {
        angular.extend(
          this.externalConfig,
          config,
          config.engine
            ? {engine: config.engine.id}
            : {}
        );
      } else {
        this.resetConfig();
      }
    }
  }

  resetConfig() {
    if (this.externalConfig) {
      if (this.previousConfig) {
        angular.extend(
          this.externalConfig,
          this.previousConfig,
          this.previousConfig.engine
            ? {engine: this.previousConfig.engine.id}
            : {}
        );
      } else {
        for (let key of Object.keys(this.externalConfig)) {
          delete this.externalConfig[key];
        }
      }
    }
  }
}


export const SpeechRecognitionConfigComponent = {
  restrict   : 'E',
  template   : require('./speech-recognition-config.html'),
  controller : SpeechRecognitionConfigController,
  bindings   : {externalConfig: '=config', errors: '=?'},
}



// WEBPACK FOOTER //
// ./src/speech/speech-recognition-config.js